import mutations from './mutations.js';
import Actions from './actions.js';

const rowCategoriesModule = serviceClient => {
  const actions = Actions(serviceClient);
  return {
    namespaced: true,
    state: () => ({
      rowCategories: [],
      pageCount: 0,
      currentPage: 1,
      editCategory: false,
      categoryToDelete: undefined,
      categoryToEdit: undefined
    }),
    mutations,
    actions
  };
};

export default rowCategoriesModule;
